/* eslint-disable */
import axios from "axios";
import moment from "moment";
import jwt_decode from "jwt-decode";
import store from "../../store/index";
import VuePdfEmbed from "vue-pdf-embed";
import Multiselect from "@vueform/multiselect";

import QcReviewPopup from "./../TmfDocApprovals/QcReviewPopup.vue";
import customModal from "../customModal/customModal.vue";
import docversionpopup from "../docversionpopup/docversionpopup.vue";
import manageDocRecipient from "../ManageDocRecipient/ManageDocRecipient.vue";
import signaturePopUp from "../signaturePopUp/signaturePopUp.vue";
import SignatureBlockPopup from "./SignatureBlockPopup.vue";
import documentSignaturePopup from "./documentSignaturePopup.vue";

export default {
  props: {
    referenceId: String,
    versionId: String,
    hideDocumentViewIcons: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    VuePdfEmbed,
    customModal,
    QcReviewPopup,
    docversionpopup,
    manageDocRecipient,
    Multiselect,
    signaturePopUp,
    SignatureBlockPopup,
    documentSignaturePopup,
  },

  data() {
    return {
      maximized: true,
      issigned: false,
      selectedversionid: "",
      popupTitle: "",
      versiondetails: {},
      isDocLoading: true,
      pdfDocument: null,
      pdfPageSizes: {},
      pdfViewerWidth: 0,
      pdfViewerResizeTimer: null,
      isSignLoading: false,
      passversiontodocusign: "",
      showLoading: false,
      signatureConfigMode: false,
      signatureBlockMode: false,
      isDrawingSignature: false,
      signatureStartPoint: null,
      signatureRectPreview: null,
      signaturePointerId: null,
      pdfScrollTop: 0,
      pdfScrollLeft: 0,
      selectedSignatureCoordinates: null,
      activeDocumentTab: "original",
      hasSetInitialTab: false,
      signedDocumentId: null,
      signedDocumentVersion: null,
      originalDocumentId: null,
      originalDocumentVersion: null,
      signatureConfigForm: {
        signingOrder: "",
        displayName: "",
        reason: "",
        role: "",
        required: true,
      },
      signatureConfigErrors: {
        documentName: "",
        signingOrder: "",
        displayName: "",
        reason: "",
        role: "",
        coordinates: "",
      },
      savingSignatureConfig: false,
      savedSignatureConfigs: [],
      signatureConfigDetails: null,
      showSignatureBlockPopup: false,
      signatureBlockDraft: null,
      loadingSavedSignatureConfigs: false,
      savedSignatureDefaultSize: {
        width: 180,
        height: 60,
      },
      signatureRoleOptions: ["Subject", "Investigator", "Witness"],
      signatureReasonOptions: ["Consent to Participate", "Investigator Confirmation", "Witness Confirmation", "Translation Confirmation", "Consent on Behalf of Subject"],
      showDetailModal: false,
      selectedDetailType: "",
      selectedDetail: null,

      mainapi: `${process.env.VUE_APP_Service_URL}`,
      baseurl: process.env.VUE_APP_Service_URL,
      baseapi: process.env.VUE_APP_Service_URL,
      fileuploadurl: process.env.VUE_APP_File_upload_URL + "/document",
      office: ["xls", "xlsx", "doc", "docx"],

      envelopeId: "",
      signingUrl: false,
      docusign: {},
      showdocsigniframe: false,
      docusigndata: [],
      docsignurl: "",
      docuSignWatchTimer: null,

      roleList: [],
      selectedRole: [],

      approvals: {
        documentId: this.referenceId,
        studyId: store.getters.getStudyIs,
        actionType: this.selectedApprovalType,
        version: this.versionId,
        approveList: [],
        reviewList: [],
        qcList: [],
      },

      datacorrected: {
        sent: "Pending",
        created: "Awaiting",
        completed: "Signed",
      },

      review: {
        documentId: this.referenceId,
        studyId: store.getters.getStudyId,
        version: this.versionId,
        actionType: "review",
        reviewList: [],
      },

      qcs: {
        documentId: this.referenceId,
        studyId: store.getters.getStudyId,
        version: this.versionId,
        actionType: "qc",
        qcList: [],
      },

      documentLoader: false,
      singleApproval: {
        documentId: this.referenceId,
        studyid: store.getters.getStudyId,
        version: this.versionId,
        approveList: {
          approvalType: "",
          approvalTypeID: "",
          approvedByEmail: "",
          isRequired: true,
          comments: "",
        },
      },

      list: [],
      documentUploadFields: {
        folderid: "",
        documentIdd: "",
        title: "",
        description: "",
        owner: "",
        department: "",
        category: "",
        standard: "",
        documentType: "",
        version: "",
        expiryDate: "",
        formData: "",
        changesHistory: "",
      },

      approver: {},
      documentDescription: "",
      documentVersions: [],
      assignedByUsername: "",
      approvedStatus: "",
      reviewStatus: "",
      qcStatus: "",
      status: "",
      comments: "",
      showValue: "",
      approvaldetails: "",
      loadingSingleSave: [false],
      userobject: [],
      userList: [],
      removeUser: [],
      roleIds: [],
      isRequired: [],
      isSelectedUser: [],
      isDisabled: [],
      documentValidationsError: [false, false, false, false, false, false, false],
      loadingDocUpload: false,
      loadingSaveModalBtn: false,

      format: "",
      source: "",
      sourceFallback: "",
      hasTriedFallbackSource: false,
      officeurl: "",
      NewFile: "",
      presentPage: "",
      currentProcess: "",
      currentDocProcess: "",
      documentApprovalModal: false,
      uploadDocumentModal: false,
      showSave: false,
      ownerList: [],
      sourcePage: "",
      getApproverList: [],

      selectedsignorder: "",
      selectedenvelopid: "",
      approversEmails: [],
      designation: "",
      designationList: [],
      selectedrecepientemal: "",
      documentEdit: false,
      docTitle: "",
      docVersion: "",
      approvalType: "",
      canSelectApprovers: false,
      canSelectQC: false,
      canSelectReviewers: false,
      canUpload: false,
      canSelectSigners: false,
      canCompleteDocument: false,
      docusignRelayAllowedOrigin: window.location.origin,
      testiframe: false,
      updatedBy: "",
      uploadedBy: "",
      standard: "",
      currentVersion: "",
      department: "",
      owner: "",
      documentTitle: "",
      type: "",
      readMore: [false],
      checkstatusvalue: "Pending , Approved , Rejected",
      versionList: [],
      documentid: "",
      newversionforsigner: "",
      selectedApprovalType: "",
      isSigningUrlFetching: false,
      selectedDueDate: null,
      showDocRecipient: false,
      docDetails: {},
      modalContext: "",
      qcReviewApprovalStatus: {},
      actionType: "",
      approveButtonLabel: "Approve",
      signstatus: "",
      completionStatus: "",
      consentRecordId: "",
      consentRecordDetails: null,
      showConsentDocumentActions: false,
      signpopUp: false,
      signatuestatus: "",
      signatureformId: "",
      modalStatus: "",
      showDocumentSignPopup: false,
      docSignPopupEmail: "",
      docSignPopupOrder: "",

      // from Development branch
      loggedinUser: {},
      statuses: {
        reviewed: {
          email: "",
          status: "",
          actionTime: ""
        },
        qced: {
          email: "",
          status: "",
          actionTime: ""
        },
        approved: {
          email: "",
          status: "",
          actionTime: ""
        },
        signed: {
          email: "",
          status: "",
          envelopeId: "",
          actionTime: "",
          completed: false,
          timestamp: ""
        }
      },
      showActionPopup: false,
      actionType: "",
      actionStatus: "",
      defaultdate: "",
      designationList: [],
      readMore: [],
      showsignareaModal: false,
      signareadoctitle: "",
    }

  },

  beforeRouteEnter(to, from, next) {
    const src = from?.name || "direct";
    localStorage.setItem("presentPage", src);
    next((vm) => {
      vm.previousRouteName = src;
    });
  },

  unmounted() {
    delete window.showAlert;
    if (this.docuSignWatchTimer) clearInterval(this.docuSignWatchTimer);
    if (this.pdfViewerResizeTimer) clearTimeout(this.pdfViewerResizeTimer);
    window.removeEventListener("resize", this.onDocumentViewerResize);
    localStorage.removeItem("documentViewSource");
    localStorage.removeItem("presentPage");
  },

  async mounted() {
    window.addEventListener("resize", this.onDocumentViewerResize);
    this.selectedversionid = this.versionId;
    window.showAlert = this.showAlert.bind(this);
    this.presentPage = localStorage.getItem("presentPage") || "direct";
    this.defaultdate = localStorage.getItem("dateformat");
    if (this.presentPage === "folderDocLogin") {
      this.currentProcess = localStorage.getItem("currentdocprocess");
      if (this.currentProcess !== null && this.currentProcess !== undefined) {
        this.showValue = "Pending";
      }
    }

    if (["TmfDocReviewList", "TmfDocQcList", "etmfdoc", "etmfuserdashboard"].includes(this.presentPage)) {
      this.idtoken = store.getters.getToken;
      await this.getApprovalStatus();
    }
    await this.getconsentrecordbyid();
    console.log('setdocversion ISSS', this.referenceId)
    await this.checkqcReviewApproval("");
    await this.setfilename();
    await this.setdoc();
    await this.getVersionHistory();
    await this.approveLabel();

    await this.getTokenInfo();
    console.log("this.versiondetails", this.versiondetails);
    console.log("this.loggedinUser.email", this.loggedinUser.email);
    await this.setActionBtnVisiblity(this.versiondetails, this.loggedinUser.email);
    this.readMore = this.versionList.map(() => false);
  },

  computed: {
    hasSignedDocument() {
      return !!this.signedDocumentId;
    },
    signedDocumentSource() {
      if (!this.signedDocumentId) return "";
      const version = this.signedDocumentVersion || "1.0";
      return `${this.baseurl}/etmf/document/documentfile/${this.signedDocumentId}?version=${version}`;
    },
    originalDocumentSource() {
      const docId = this.originalDocumentId || this.referenceId;
      const version = this.originalDocumentVersion || this.selectedversionid || "1";
      if (!docId) return "";
      return `${this.baseurl}/etmf/document/documentfile/${docId}?version=${version}`;
    },
    currentPdfSource() {
      if (this.activeDocumentTab === "signed" && this.signedDocumentId) {
        return this.signedDocumentSource;
      }
      return this.source || this.originalDocumentSource;
    },
    formatLower() {
      return (this.format || "").toLowerCase();
    },
    isSubjectProfileConsentDocumentView() {
      const sourceFromRoute = this.$route && this.$route.query
        ? this.$route.query.source
        : "";
      const source = sourceFromRoute || localStorage.getItem("documentViewSource") || "";
      //console.log("presentPage:", this.presentPage, "isSubjectProfileConsentDocumentView:", this.isSubjectProfileConsentDocumentView);
      return source === "subjectprofile-consent-record-icf";
      // return (
      //   this.presentPage === "subjectprofile" &&
      //   source === "subjectprofile-consent-record-icf"
      // );
    },
    showPdfConsentButtonArea() {
      return (
        this.formatLower === "pdf" &&
        !this.showdocsigniframe &&
        this.showConsentDocumentActions
      );
    },
    showDocumentConsentSignButton() {
      return (
        this.showPdfConsentButtonArea &&
        this.hasConsentEvent("SUBJECT_SIGNED") &&
        !this.hasConsentEvent("INVESTIGATOR_SIGNED")
      );
    },
    showDocumentConsentCompleteButton() {
      return (
        this.showPdfConsentButtonArea &&
        this.hasConsentEvent("INVESTIGATOR_SIGNED") &&
        !this.hasConsentEvent("CONSENT_COMPLETED")
      );
    },
    showPdfConsentButtons() {
      return this.showDocumentConsentSignButton || this.showDocumentConsentCompleteButton;
    },
    signatureBlockDocumentName() {
      return (
        (this.docDetails && this.docDetails.documentTitle) ||
        (this.versiondetails && this.versiondetails.fileName) ||
        (this.docDetails && this.docDetails.name) ||
        this.NewFile ||
        "Document"
      );
    },
    signatureBlockDocumentCode() {
      const version = this.selectedversionid || this.versionId || "";
      const versionNumber = Number(version);

      if (Number.isFinite(versionNumber) && versionNumber > 0) {
        return `SIGCFG-${String(versionNumber).padStart(3, "0")}`;
      }

      return version ? `SIGCFG-${String(version).slice(0, 8)}` : "";
    },
    signatureBlockRoleOptions() {
      const defaultRoles = ["QA Lead", "Principal Investigator", "Sub Investigator", "CRA", "Data Manager"];
      const configuredRoles = Array.isArray(this.signatureRoleOptions) ? this.signatureRoleOptions : [];

      return [...new Set([...defaultRoles, ...configuredRoles].filter(Boolean))];
    },
    signatureRectStyle() {
      if (!this.signatureRectPreview) return {};
      return {
        left: `${this.signatureRectPreview.documentLeft - this.pdfScrollLeft}px`,
        top: `${this.signatureRectPreview.documentTop - this.pdfScrollTop}px`,
        width: `${this.signatureRectPreview.width}px`,
        height: `${this.signatureRectPreview.height}px`,
      };
    },
  },

  methods: {
    maximizeorminimise(val) {
      this.maximized = val;
      this.$nextTick(() => {
        this.updatePdfViewerWidth();
        this.onPdfScroll();
      });
    },
    updatePdfViewerWidth() {
      const viewer = this.$refs.pdfViewer;
      if (!viewer) return;

      const width = Math.floor(
        viewer.clientWidth || viewer.getBoundingClientRect().width || 0
      );

      if (width > 0 && width !== this.pdfViewerWidth) {
        this.pdfViewerWidth = width;
      }
    },
    onDocumentViewerResize() {
      if (this.pdfViewerResizeTimer) clearTimeout(this.pdfViewerResizeTimer);
      this.pdfViewerResizeTimer = setTimeout(() => {
        this.updatePdfViewerWidth();
        this.onPdfScroll();
      }, 100);
    },
    getConsentRecordIdForDocumentView() {
      const queryConsentRecordId =
        this.$route && this.$route.query
          ? this.$route.query.consentRecordId
          : "";
      const consentRecordId =
        queryConsentRecordId ||
        localStorage.getItem("consentRecordId") ||
        "";

      if (consentRecordId) {
        localStorage.setItem("consentRecordId", consentRecordId);
      }

      return consentRecordId;
    },
    getConsentStudyIdForDocumentView() {
      const queryStudyId =
        this.$route && this.$route.query
          ? this.$route.query.studyId
          : "";
      const studyId =
        queryStudyId ||
        localStorage.getItem("consentStudyId") ||
        store.getters.getStudyIs ||
        store.getters.getStudyId ||
        "";

      if (studyId) {
        localStorage.setItem("consentStudyId", studyId);
      }

      return studyId;
    },
    getConsentSubjectIdForDocumentView() {
      const querySubjectId =
        this.$route && this.$route.query
          ? this.$route.query.subjectId
          : "";
      const subjectId =
        querySubjectId ||
        localStorage.getItem("consentSubjectId") ||
        localStorage.getItem("patientId") ||
        "";

      if (subjectId) {
        localStorage.setItem("consentSubjectId", subjectId);
      }

      return subjectId;
    },
    normalizeConsentEventType(eventType) {
      return String(eventType || "").trim().toUpperCase();
    },
    getConsentEventTypes(record = this.consentRecordDetails) {
      const events = Array.isArray(record?.events) ? record.events : [];
      return events.map((event) => this.normalizeConsentEventType(event?.eventType));
    },
    hasConsentEvent(eventType, record = this.consentRecordDetails) {
      return this.getConsentEventTypes(record).includes(
        this.normalizeConsentEventType(eventType)
      );
    },
    getConsentResults(responseData) {
      if (Array.isArray(responseData?.results)) {
        return responseData.results;
      }
      if (Array.isArray(responseData?.data?.results)) {
        return responseData.data.results;
      }
      if (Array.isArray(responseData)) {
        return responseData;
      }
      return [];
    },
    async getConsentRecordFromList() {
      const consentRecordId = this.getConsentRecordIdForDocumentView();
      const studyId = this.getConsentStudyIdForDocumentView();
      const subjectId = this.getConsentSubjectIdForDocumentView();

      if (!studyId || !subjectId || !consentRecordId) {
        console.warn("Skipping consent status lookup: missing identifiers", {
          studyId,
          subjectId,
          consentRecordId,
        });
        return null;
      }

      const idtoken = store.getters.getIdToken;
      const res = await axios.get(
        `${this.baseurl}/management/patientdocument/listconsentformbystudy`,
        {
          params: {
            studyId,
            subjectId,
            consentRecordId,
          },
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        }
      );
      const results = this.getConsentResults(res.data);
      const record =
        results.find((item) => String(item?.consentRecordId || "") === String(consentRecordId)) ||
        results[0] ||
        null;

      if (record) {
        localStorage.setItem("consentRecordId", record.consentRecordId || consentRecordId);
        localStorage.setItem("consentSubjectId", record.subjectId || record.subjectID || subjectId);
        localStorage.setItem("consentStudyId", record.studyId || record.studyID || studyId);
      }

      return record;
    },
    async refreshConsentRecordFromList() {
      try {
        this.consentRecordDetails = await this.getConsentRecordFromList();
        this.showConsentDocumentActions = Boolean(this.consentRecordDetails);
        return this.consentRecordDetails;
      } catch (err) {
        console.log(err);
        this.showConsentDocumentActions = false;
        return null;
      }
    },
    getSignedConsentDocumentId(record = this.consentRecordDetails) {
      return (
        record?.signedICF?.signedicfDocumentId ||
        record?.signedICF?.signedICFDocumentId ||
        record?.signedICF?.signedIcfDocumentId ||
        record?.signedICF?.documentId ||
        record?.signedICF?.documentID ||
        record?.signedICF?.storagePath ||
        ""
      );
    },
    getConsentIcfDocumentId(record = this.consentRecordDetails) {
      return (
        record?.icf?.icfDocumentId ||
        record?.documentId ||
        record?.documentReferenceId ||
        record?.documentID ||
        ""
      );
    },
    getConsentIcfDocumentVersion(record = this.consentRecordDetails) {
      return (
        record?.icf?.version ||
        record?.versionNumber ||
        record?.latestVersion ||
        record?.version ||
        record?.versionId ||
        this.selectedversionid ||
        this.versionId ||
        0
      );
    },
    async reloadConsentDocumentAfterSign(record = this.consentRecordDetails) {
      const documentId =
        this.getSignedConsentDocumentId(record) ||
        this.getConsentIcfDocumentId(record) ||
        this.referenceId;
      const version = this.getConsentIcfDocumentVersion(record);

      if (!documentId) {
        await this.setdoc(true);
        return;
      }

      if (
        String(documentId) !== String(this.referenceId) ||
        String(version) !== String(this.selectedversionid)
      ) {
        await this.$router.replace({
          path: `/documentview/${documentId}/${version}`,
          query: {
            ...this.$route.query,
            source: "subjectprofile-consent-record-icf",
            consentRecordId: this.getConsentRecordIdForDocumentView(),
            subjectId: this.getConsentSubjectIdForDocumentView(),
            studyId: this.getConsentStudyIdForDocumentView(),
          },
        });
        this.selectedversionid = version;
        await this.$nextTick();
      }

      await this.setfilename();
      await this.setdoc(true);
    },
    async getconsentrecordbyid() {
      this.showConsentDocumentActions = false;
      this.consentRecordDetails = null;

      if (!this.isSubjectProfileConsentDocumentView) {
        return;
      }

      const consentRecordId = this.getConsentRecordIdForDocumentView();
      this.consentRecordId = consentRecordId;

      if (!consentRecordId) {
        return;
      }

      try {
        await this.refreshConsentRecordFromList();
      } catch (err) {
        console.log(err);
        this.showConsentDocumentActions = false;
      }
    },
    async consentcompleted(status = "CONSENT_COMPLETED") {
      if (this.hasConsentEvent("CONSENT_COMPLETED")) {
        return;
      }

      const consentRecordId = this.consentRecordId || this.getConsentRecordIdForDocumentView();
      if (!consentRecordId) {
        return;
      }

      const idtoken = store.getters.getIdToken;
      const record = this.consentRecordDetails || {};

      await axios.put(
        `${this.baseurl}/management/patientdocument/updateconsentbysubject`,
        {
          consentId: consentRecordId,
          studyID: record.studyID || record.studyId || this.getConsentStudyIdForDocumentView(),
          subjectID: record.subjectID || record.subjectId || record.patientId || this.getConsentSubjectIdForDocumentView(),
          status,
          ipAddress: "",
          device: "",
          browser: "",
          os: "",
          location: "",
          signatureType: "",
          signatureReason: "",
          comments: "",
          role: "",
        },
        {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        }
      ).catch((err) => {
        console.log(err);
      });
    },
    async signatureClick(status) {
      this.signpopUp = true;
      this.signatuestatus = status;
      this.signatureformId = this.referenceId;
      if (status === "Signed") {
        this.modalStatus = "Sign";
      } else if (status === "Unsigned") {
        this.modalStatus = "Unsign";
      }
    },
    async CloseModelwithoutsign() {
      this.signpopUp = false;
    },
    async CloseModelCall() {
      this.signpopUp = false;
      await this.consentcompleted("INVESTIGATOR_SIGNED");
      const record = await this.refreshConsentRecordFromList();
      await this.reloadConsentDocumentAfterSign(record);
    },
    async SignedCompletedclose() {
      this.signpopUp = false;
      await this.consentcompleted("INVESTIGATOR_SIGNED");
      await this.consentcompleted("CONSENT_COMPLETED");
      const record = await this.refreshConsentRecordFromList();
      await this.reloadConsentDocumentAfterSign(record);
      if (this.hasConsentEvent("CONSENT_COMPLETED")) {
        alert("Consent Completed");
      }
    },
    async completesigned() {
      await this.consentcompleted("CONSENT_COMPLETED");
      await this.getconsentrecordbyid();
      if (this.hasConsentEvent("CONSENT_COMPLETED")) {
        alert("Consent Completed");
      }
    },
    async signPdfForm() {
      await this.signatureClick("Signed");
    },
    toggleRead(index) {
      // Vue 2 requires $set for reactivity, Vue 3 does not
      this.readMore[index] = !this.readMore[index];
    },
    toggleSignatureBlockConfiguration() {
      if (this.formatLower !== "pdf" || this.showdocsigniframe) return;
      this.signatureBlockMode = !this.signatureBlockMode;
      this.signatureConfigMode = false;
      this.isDrawingSignature = false;
      this.signatureStartPoint = null;
      this.signaturePointerId = null;
      this.showSignatureBlockPopup = false;

      if (this.signatureBlockMode) {
        this.signatureRectPreview = null;
        this.selectedSignatureCoordinates = null;
        this.$nextTick(() => this.onPdfScroll());
      } else {
        this.signatureRectPreview = null;
        this.selectedSignatureCoordinates = null;
      }
    },
    closeSignatureBlockPopup() {
      this.showSignatureBlockPopup = false;
      this.signatureBlockMode = false;
      this.selectedSignatureCoordinates = null;
      this.signatureRectPreview = null;
    },
    async saveSignatureBlockDraft(payload) {
      if (this.savingSignatureConfig) return;

      const apiCoordinates = this.getSignatureApiCoordinates();
      if (!apiCoordinates) {
        alert("Signature block coordinates are unavailable. Please draw the block again.");
        return;
      }

      const form = payload.form || {};
      const signer = Array.isArray(payload.signers) ? payload.signers[0] : null;
      const assignmentTypes = {
        usersOnly: "User",
        roleOnly: "Role",
        roleUsers: "UserAndRole",
      };
      const assignmentType = assignmentTypes[form.assignmentType];
      const usesUser = assignmentType === "User" || assignmentType === "UserAndRole";
      const usesRole = assignmentType === "Role" || assignmentType === "UserAndRole";
      const role = usesRole
        ? (form.roleId || (signer && (signer.roleId || signer.roleID)) || form.role || null)
        : null;

      const requestPayload = {
        documentId: this.referenceId,
        documentVersion: String(this.selectedversionid || this.versionId || ""),
        documentName: this.signatureBlockDocumentName || this.getSignatureDocumentName(),
        signaturesConfigs: [{
          signatureKey: "",
          displayName: String(form.displayName || "").trim(),
          reason: String(form.reason || "").trim(),
          fieldType: "signature",
          signingOrder: Number(form.signingOrder),
          required: true,
          pageNumber: apiCoordinates.pageNumber,
          coordinates: {
            x: apiCoordinates.coordinates.x,
            y: apiCoordinates.coordinates.y,
          },
          signatureMethods: ["UserNamePassword Authentication"],
          allowReSign: true,
          isActive: true,
          assignmentType,
          assignedUsers: [{
            userId: usesUser && signer
              ? (signer.userId || signer.id)
              : null,
            userEmail: usesUser && signer ? signer.email : null,
            role,
          }],
        }],
      };

      this.savingSignatureConfig = true;
      try {
        const idtoken = store.getters.getIdToken;
        await axios.post(
          `${this.baseurl}/signature/signatureconfig/createconfig`,
          requestPayload,
          { headers: { Authorization: "Bearer " + idtoken, "Content-Type": "application/json" } }
        );
        this.signatureBlockDraft = null;
        this.showSignatureBlockPopup = false;
        this.signatureBlockMode = false;
        this.selectedSignatureCoordinates = null;
        this.signatureRectPreview = null;
        alert("Signature block saved successfully.");
        await this.getSavedSignatureConfigurations();
      } catch (err) {
        console.error("Error saving signature block:", err);
        const responseData = err && err.response && err.response.data;
        alert((responseData && (responseData.message || responseData.detail)) || "Unable to save signature block.");
      } finally {
        this.savingSignatureConfig = false;
      }
    },
    toggleSignatureConfiguration() {
      if (this.formatLower !== "pdf" || this.showdocsigniframe) return;
      this.signatureConfigMode = !this.signatureConfigMode;
      this.signatureBlockMode = false;
      this.isDrawingSignature = false;
      this.signatureStartPoint = null;
      this.signaturePointerId = null;
      this.showSignatureBlockPopup = false;

      if (this.signatureConfigMode) {
        this.signatureRectPreview = null;
        this.$nextTick(() => this.onPdfScroll());
      } else {
        this.signatureRectPreview = null;
        this.selectedSignatureCoordinates = null;
      }
    },
    resetSignatureConfiguration() {
      this.signatureConfigMode = false;
      this.signatureBlockMode = false;
      this.isDrawingSignature = false;
      this.signatureStartPoint = null;
      this.signatureRectPreview = null;
      this.signaturePointerId = null;
      this.pdfScrollTop = 0;
      this.pdfScrollLeft = 0;
      this.selectedSignatureCoordinates = null;
      this.showsignareaModal = false;
      this.showSignatureBlockPopup = false;
      this.savingSignatureConfig = false;
      this.savedSignatureConfigs = [];
      this.signatureConfigDetails = null;
      this.loadingSavedSignatureConfigs = false;
      this.resetSignatureConfigForm();
    },
    onPdfScroll() {
      const viewer = this.$refs.pdfViewer;
      if (!viewer) return;
      this.pdfScrollTop = viewer.scrollTop || 0;
      this.pdfScrollLeft = viewer.scrollLeft || 0;
    },
    getPdfPageElements() {
      const viewer = this.$refs.pdfViewer;
      if (!viewer) return [];

      let pageElements = Array.from(viewer.querySelectorAll(".vue-pdf-embed__page"));
      if (!pageElements.length) {
        pageElements = Array.from(viewer.querySelectorAll("canvas, svg"));
      }

      return pageElements;
    },
    getPdfRenderedPages() {
      const viewer = this.$refs.pdfViewer;
      const pageElements = this.getPdfPageElements();
      if (!viewer || !pageElements.length) return [];

      const viewerRect = viewer.getBoundingClientRect();
      return pageElements.map((page, index) => {
        const pageRect = page.getBoundingClientRect();
        const left = pageRect.left - viewerRect.left + viewer.scrollLeft;
        const top = pageRect.top - viewerRect.top + viewer.scrollTop;

        return {
          index,
          pageNumber: index + 1,
          left,
          top,
          right: left + pageRect.width,
          bottom: top + pageRect.height,
          width: pageRect.width,
          height: pageRect.height,
        };
      });
    },
    async cachePdfPageSizes(pdfDocument = this.pdfDocument) {
      if (!pdfDocument || !pdfDocument.numPages) {
        this.pdfPageSizes = {};
        return;
      }

      const pageSizes = {};
      for (let pageNumber = 1; pageNumber <= pdfDocument.numPages; pageNumber += 1) {
        const page = await pdfDocument.getPage(pageNumber);
        const viewport = page.getViewport({ scale: 1 });
        pageSizes[pageNumber] = {
          width: this.roundCoordinate(viewport.width),
          height: this.roundCoordinate(viewport.height),
        };
      }

      this.pdfPageSizes = pageSizes;
    },
    getPdfPageSize(pageNumber, renderedPage = null) {
      const savedSize = this.pdfPageSizes && this.pdfPageSizes[pageNumber];
      if (savedSize && savedSize.width > 0 && savedSize.height > 0) {
        return savedSize;
      }

      if (renderedPage && renderedPage.width > 0 && renderedPage.height > 0) {
        return {
          width: renderedPage.width,
          height: renderedPage.height,
        };
      }

      return null;
    },
    getRenderedToPdfScale(renderedPage) {
      if (!renderedPage) return null;

      const pageSize = this.getPdfPageSize(renderedPage.pageNumber || renderedPage.index + 1, renderedPage);
      if (!pageSize || !renderedPage.width || !renderedPage.height) return null;

      return {
        pageSize,
        scaleX: pageSize.width / renderedPage.width,
        scaleY: pageSize.height / renderedPage.height,
      };
    },
    getPdfToRenderedScale(renderedPage) {
      const scale = this.getRenderedToPdfScale(renderedPage);
      if (!scale || !scale.scaleX || !scale.scaleY) return null;

      return {
        pageSize: scale.pageSize,
        scaleX: renderedPage.width / scale.pageSize.width,
        scaleY: renderedPage.height / scale.pageSize.height,
      };
    },
    renderedRectangleToPdfRectangle(rectangle, renderedPage) {
      const scale = this.getRenderedToPdfScale(renderedPage);
      if (!scale || !rectangle) return null;

      const x = Number(rectangle.x) || 0;
      const y = Number(rectangle.y) || 0;
      const width = Number(rectangle.width) || 0;
      const height = Number(rectangle.height) || 0;
      const pdfWidth = width * scale.scaleX;
      const pdfHeight = height * scale.scaleY;

      return this.getBottomLeftRectangle(
        {
          x: x * scale.scaleX,
          y: y * scale.scaleY,
          width: pdfWidth,
          height: pdfHeight,
        },
        scale.pageSize.height
      );
    },
    getBottomLeftRectangle(rectangle, pageHeight) {
      if (!rectangle) return null;

      const height = Number(rectangle.height) || 0;
      const width = Number(rectangle.width) || 0;
      const x = Number(rectangle.x) || 0;
      const y = Number(rectangle.y) || 0;
      const pageHeightNumber = Number(pageHeight);

      if (!Number.isFinite(pageHeightNumber) || pageHeightNumber <= 0) return null;

      return {
        x: this.roundCoordinate(x),
        y: this.roundCoordinate(pageHeightNumber - (y + height)),
        width: this.roundCoordinate(width),
        height: this.roundCoordinate(height),
      };
    },
    normalizeSignatureCoordinateSpace(value) {
      const normalized = String(value || "pdfPoints").trim().toLowerCase();

      if (
        normalized === "renderedpdfpixels" ||
        normalized === "rendered-pdf-pixels" ||
        normalized === "pixels" ||
        normalized === "pixel"
      ) {
        return "renderedPdfPixels";
      }

      return "pdfPoints";
    },
    pdfRectangleToRenderedRectangle(coordinates, renderedPage, coordinateSpace = "pdfPoints") {
      if (!coordinates || !renderedPage) return null;

      const x = Number(coordinates.x);
      const y = Number(coordinates.y);
      const width = Number(coordinates.width);
      const height = Number(coordinates.height);
      if (!Number.isFinite(x) || !Number.isFinite(y)) return null;

      const safeWidth =
        Number.isFinite(width) && width > 0
          ? width
          : this.savedSignatureDefaultSize.width;
      const safeHeight =
        Number.isFinite(height) && height > 0
          ? height
          : this.savedSignatureDefaultSize.height;

      if (this.normalizeSignatureCoordinateSpace(coordinateSpace) === "renderedPdfPixels") {
        return {
          x,
          y: this.roundCoordinate(renderedPage.height - y - safeHeight),
          width: safeWidth,
          height: safeHeight,
        };
      }

      const scale = this.getPdfToRenderedScale(renderedPage);
      if (!scale) return null;

      return {
        x: this.roundCoordinate(x * scale.scaleX),
        y: this.roundCoordinate((scale.pageSize.height - y - safeHeight) * scale.scaleY),
        width: this.roundCoordinate(safeWidth * scale.scaleX),
        height: this.roundCoordinate(safeHeight * scale.scaleY),
      };
    },
    savedSignatureRectStyle(signature) {
      const page = this.getPdfRenderedPages()[Number(signature.pageNumber || 1) - 1];
      const coordinates = signature.coordinates || {};
      const renderedRectangle = this.pdfRectangleToRenderedRectangle(
        coordinates,
        page,
        signature.coordinateSpace
      );
      if (!page || !renderedRectangle) return { display: "none" };

      return {
        left: `${page.left + renderedRectangle.x - this.pdfScrollLeft}px`,
        top: `${page.top + renderedRectangle.y - this.pdfScrollTop}px`,
        width: `${renderedRectangle.width}px`,
        height: `${renderedRectangle.height}px`,
      };
    },
    getSignatureLayerPoint(event) {
      const layer = this.$refs.signatureDrawLayer;
      const viewer = this.$refs.pdfViewer;
      if (!layer || !viewer) return null;

      const layerRect = layer.getBoundingClientRect();
      const x = Math.max(0, Math.min(event.clientX - layerRect.left, layerRect.width));
      const y = Math.max(0, Math.min(event.clientY - layerRect.top, layerRect.height));

      this.pdfScrollLeft = viewer.scrollLeft || 0;
      this.pdfScrollTop = viewer.scrollTop || 0;

      return {
        x,
        y,
        documentX: x + this.pdfScrollLeft,
        documentY: y + this.pdfScrollTop,
      };
    },
    startSignatureDraw(event) {
      if (
        (!this.signatureConfigMode && !this.signatureBlockMode) ||
        (event.pointerType === "mouse" && event.button !== 0)
      ) return;

      const point = this.getSignatureLayerPoint(event);
      if (!point) return;

      this.signaturePointerId = event.pointerId;
      this.isDrawingSignature = true;
      this.signatureStartPoint = point;
      this.signatureRectPreview = {
        documentLeft: point.documentX,
        documentTop: point.documentY,
        width: 0,
        height: 0,
      };

      if (event.currentTarget.setPointerCapture && event.pointerId !== undefined) {
        event.currentTarget.setPointerCapture(event.pointerId);
      }
    },
    moveSignatureDraw(event) {
      if (!this.isDrawingSignature || !this.signatureStartPoint) return;
      if (this.signaturePointerId !== null && event.pointerId !== this.signaturePointerId) return;

      const point = this.getSignatureLayerPoint(event);
      if (!point) return;

      this.updateSignatureRect(point);
    },
    finishSignatureDraw(event) {
      if (!this.isDrawingSignature || !this.signatureStartPoint) return;
      if (this.signaturePointerId !== null && event.pointerId !== this.signaturePointerId) return;

      const point = this.getSignatureLayerPoint(event);
      if (point) this.updateSignatureRect(point);
      this.releaseSignaturePointer(event);

      const rect = this.signatureRectPreview;
      this.isDrawingSignature = false;
      this.signatureStartPoint = null;
      this.signaturePointerId = null;

      if (!rect || rect.width < 4 || rect.height < 4) {
        this.signatureRectPreview = null;
        return;
      }

      const coordinates = this.buildSignatureCoordinates(rect);
      console.log("Signature rectangle coordinates", coordinates);
      this.selectedSignatureCoordinates = coordinates;

      if (this.signatureBlockMode) {
        this.showSignatureBlockPopup = true;
        this.signatureBlockMode = false;
        return;
      }

      this.prepareSignatureConfigForm();
      this.showsignareaModal = true;
      this.signatureConfigMode = false;
    },
    closesignareaModal() {
      this.showsignareaModal = false;
      this.savingSignatureConfig = false;
      this.selectedSignatureCoordinates = null;
      this.signatureRectPreview = null;
      this.resetSignatureConfigForm();
    },
    prepareSignatureConfigForm() {
      this.signareadoctitle = this.getSignatureDocumentName();
      this.signatureConfigForm = {
        signingOrder: this.signatureConfigForm.signingOrder || "",
        displayName: this.signatureConfigForm.displayName || "",
        reason: this.signatureConfigForm.reason || "",
        role: this.signatureConfigForm.role || "",
        required: true,
      };
      this.resetSignatureConfigErrors();
    },
    resetSignatureConfigForm() {
      this.signareadoctitle = "";
      this.signatureConfigForm = {
        signingOrder: "",
        displayName: "",
        reason: "",
        role: "",
        required: true,
      };
      this.resetSignatureConfigErrors();
    },
    resetSignatureConfigErrors() {
      this.signatureConfigErrors = {
        documentName: "",
        signingOrder: "",
        displayName: "",
        reason: "",
        role: "",
        coordinates: "",
      };
    },
    clearSignatureConfigError(field) {
      if (this.signatureConfigErrors[field]) {
        this.signatureConfigErrors[field] = "";
      }
    },
    getSignatureDocumentName() {
      return (
        (this.docDetails && this.docDetails.documentTitle) ||
        (this.versiondetails && this.versiondetails.fileName) ||
        (this.docDetails && this.docDetails.name) ||
        this.NewFile ||
        ""
      );
    },
    cancelSignatureDraw(event) {
      if (!this.isDrawingSignature) return;
      this.releaseSignaturePointer(event);
      this.isDrawingSignature = false;
      this.signatureStartPoint = null;
      this.signaturePointerId = null;
      this.signatureRectPreview = null;
    },
    releaseSignaturePointer(event) {
      if (
        event.currentTarget.releasePointerCapture &&
        event.pointerId !== undefined &&
        event.currentTarget.hasPointerCapture &&
        event.currentTarget.hasPointerCapture(event.pointerId)
      ) {
        event.currentTarget.releasePointerCapture(event.pointerId);
      }
    },
    updateSignatureRect(point) {
      const start = this.signatureStartPoint;
      const documentLeft = Math.min(start.documentX, point.documentX);
      const documentTop = Math.min(start.documentY, point.documentY);

      this.signatureRectPreview = {
        documentLeft,
        documentTop,
        width: Math.abs(point.documentX - start.documentX),
        height: Math.abs(point.documentY - start.documentY),
      };
    },
    buildSignatureCoordinates(rect) {
      const points = this.getRectanglePoints(rect.documentLeft, rect.documentTop, rect.width, rect.height);

      return {
        documentId: this.referenceId,
        version: this.selectedversionid,
        coordinateSpace: "pdfPoints",
        rectangle: {
          x: this.roundCoordinate(rect.documentLeft),
          y: this.roundCoordinate(rect.documentTop),
          width: this.roundCoordinate(rect.width),
          height: this.roundCoordinate(rect.height),
        },
        points,
        page: this.getSignaturePageCoordinates(points),
      };
    },
    getRectanglePoints(x, y, width, height) {
      return {
        topLeft: {
          x: this.roundCoordinate(x),
          y: this.roundCoordinate(y),
        },
        topRight: {
          x: this.roundCoordinate(x + width),
          y: this.roundCoordinate(y),
        },
        bottomRight: {
          x: this.roundCoordinate(x + width),
          y: this.roundCoordinate(y + height),
        },
        bottomLeft: {
          x: this.roundCoordinate(x),
          y: this.roundCoordinate(y + height),
        },
      };
    },
    getSignaturePageCoordinates(documentPoints) {
      const viewer = this.$refs.pdfViewer;
      if (!viewer) return null;

      const centerX = (documentPoints.topLeft.x + documentPoints.bottomRight.x) / 2;
      const centerY = (documentPoints.topLeft.y + documentPoints.bottomRight.y) / 2;
      const pages = this.getPdfRenderedPages();

      const page =
        pages.find((item) => centerX >= item.left && centerX <= item.right && centerY >= item.top && centerY <= item.bottom) ||
        pages.find((item) => documentPoints.topLeft.y >= item.top && documentPoints.topLeft.y <= item.bottom);

      if (!page) return null;

      const toPagePoint = (point) => ({
        x: this.roundCoordinate(point.x - page.left),
        y: this.roundCoordinate(point.y - page.top),
      });

      const pagePoints = {
        topLeft: toPagePoint(documentPoints.topLeft),
        topRight: toPagePoint(documentPoints.topRight),
        bottomRight: toPagePoint(documentPoints.bottomRight),
        bottomLeft: toPagePoint(documentPoints.bottomLeft),
      };
      const renderedLeft = Math.max(0, Math.min(pagePoints.topLeft.x, page.width));
      const renderedTop = Math.max(0, Math.min(pagePoints.topLeft.y, page.height));
      const renderedRight = Math.max(0, Math.min(pagePoints.bottomRight.x, page.width));
      const renderedBottom = Math.max(0, Math.min(pagePoints.bottomRight.y, page.height));
      if (renderedRight <= renderedLeft || renderedBottom <= renderedTop) return null;

      const renderedRectangle = {
        x: this.roundCoordinate(renderedLeft),
        y: this.roundCoordinate(renderedTop),
        width: this.roundCoordinate(renderedRight - renderedLeft),
        height: this.roundCoordinate(renderedBottom - renderedTop),
      };
      const pdfRectangle = this.renderedRectangleToPdfRectangle(renderedRectangle, page);
      const pageSize = this.getPdfPageSize(page.index + 1, page);
      const apiRectangle = pdfRectangle || this.getBottomLeftRectangle(renderedRectangle, page.height);
      if (!apiRectangle) return null;

      return {
        pageNumber: page.index + 1,
        pageWidth: this.roundCoordinate(pageSize ? pageSize.width : page.width),
        pageHeight: this.roundCoordinate(pageSize ? pageSize.height : page.height),
        coordinateSpace: pdfRectangle ? "pdfPoints" : "renderedPdfPixels",
        rectangle: apiRectangle,
        renderedRectangle,
        points: pagePoints,
      };
    },
    getSignatureApiCoordinates() {
      const page = this.selectedSignatureCoordinates && this.selectedSignatureCoordinates.page;
      const rectangle = page && page.rectangle;

      if (!rectangle) return null;

      return {
        pageNumber: page && page.pageNumber ? page.pageNumber : 1,
        coordinateSpace: page && page.coordinateSpace ? page.coordinateSpace : "pdfPoints",
        pageWidth: page && page.pageWidth ? page.pageWidth : 0,
        pageHeight: page && page.pageHeight ? page.pageHeight : 0,
        coordinates: {
          x: this.roundCoordinate(Number(rectangle.x) || 0),
          y: this.roundCoordinate(Number(rectangle.y) || 0),
          width: this.roundCoordinate(Number(rectangle.width) || 0),
          height: this.roundCoordinate(Number(rectangle.height) || 0),
        },
      };
    },
    createSignatureConfigPayload() {
      const apiCoordinates = this.getSignatureApiCoordinates();
      const signingOrder = Number(this.signatureConfigForm.signingOrder);

      return {
        documentId: this.referenceId,
        documentVersion: String(this.selectedversionid || ""),
        documentName: this.signareadoctitle || this.getSignatureDocumentName(),
        signaturesConfigs: [
          {
            signatureKey: "",
            displayName: this.signatureConfigForm.displayName.trim(),
            reason: this.signatureConfigForm.reason.trim(),
            fieldType: "signature",
            signingOrder,
            required: !!this.signatureConfigForm.required,
            pageNumber: apiCoordinates.pageNumber,
            coordinates: {
              x: apiCoordinates.coordinates.x,
              y: apiCoordinates.coordinates.y,
            },
            signatureMethods: ["UserNamePassword Authentication"],
            allowReSign: true,
            isActive: true,
            assignmentType: this.presentPage === "icfListing" ? "Role" : "User",
            assignedUsers: [
              {
                userId: null,
                userEmail: null,
                role: String(this.signatureConfigForm.role || ""),
              },
            ],
          },
        ],
      };
    },
    createSignatureKey(pageNumber, signingOrder) {
      return [
        "signature",
        this.referenceId,
        this.selectedversionid,
        pageNumber,
        signingOrder,
        Date.now(),
      ]
        .filter((part) => part !== undefined && part !== null && part !== "")
        .join("-");
    },
    async getSavedSignatureConfigurations() {
      if (this.formatLower !== "pdf" || !this.referenceId) {
        this.savedSignatureConfigs = [];
        this.signatureConfigDetails = null;
        return;
      }

      const idtoken = store.getters.getIdToken;
      this.loadingSavedSignatureConfigs = true;

      try {
        const version = this.selectedversionid || this.versionId || "";
        const res = await axios.get(
          `${this.baseurl}/signature/signatureconfig/getconfigbydocumentid?documentId=${encodeURIComponent(this.referenceId)}&version=${encodeURIComponent(version)}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );

        const records = Array.isArray(res.data) ? res.data : res.data ? [res.data] : [];
        const currentVersion = String(this.selectedversionid || "");
        const matchingRecords = records.filter((record) => {
          if (!record || !record.documentVersion || !currentVersion) return true;
          const savedVersion = String(record.documentVersion);
          const savedVersionNumber = Number(savedVersion);
          const currentVersionNumber = Number(currentVersion);

          return (
            savedVersion === currentVersion ||
            (
              Number.isFinite(savedVersionNumber) &&
              Number.isFinite(currentVersionNumber) &&
              savedVersionNumber === currentVersionNumber
            )
          );
        });

        this.signatureConfigDetails = matchingRecords[0] || records[0] || null;
        console.log("signatureConfigDetails:", this.signatureConfigDetails);
        if (this.signatureConfigDetails) {
          if (this.signatureConfigDetails.documentId) {
            this.originalDocumentId = this.signatureConfigDetails.documentId;
          }
          if (this.signatureConfigDetails.documentVersion) {
            this.originalDocumentVersion = this.signatureConfigDetails.documentVersion;
          }

          const envelopDetails = this.signatureConfigDetails.envelopDetails;
          if (envelopDetails && Array.isArray(envelopDetails.events) && envelopDetails.events.length > 0) {
            const lastEvent = envelopDetails.events[envelopDetails.events.length - 1];
            if (lastEvent && lastEvent.signedDocumentId) {
              this.signedDocumentId = lastEvent.signedDocumentId;
              this.signedDocumentVersion = lastEvent.signedDocumentVersion || "1.0";
              console.log("Extracted signedDocumentId:", this.signedDocumentId);
              if (!this.hasSetInitialTab) {
                if (this.$route && this.$route.query && this.$route.query.tab === 'signed') {
                  this.activeDocumentTab = 'signed';
                }
                this.hasSetInitialTab = true;
              }
            } else {
              this.signedDocumentId = null;
            }
          } else {
            this.signedDocumentId = null;
            console.log("No valid envelopDetails.events found.");
          }
        } else {
          this.signedDocumentId = null;
        }

        this.savedSignatureConfigs = matchingRecords
          .flatMap((record) => {
            const signatures = Array.isArray(record.signaturesConfigs)
              ? record.signaturesConfigs
              : Array.isArray(record.signatures)
                ? record.signatures
                : [];
            return signatures.map((signature, index) => this.normalizeSavedSignatureConfig(signature, record, index));
          })
          .filter((signature) => signature && signature.isActive !== false);

        this.$nextTick(() => this.onPdfScroll());
      } catch (err) {
        console.error("Error fetching signature configuration:", err);
        this.signatureConfigDetails = null;
        this.savedSignatureConfigs = [];
      } finally {
        this.loadingSavedSignatureConfigs = false;
      }
    },
    normalizeSavedSignatureConfig(signature, record, index) {
      if (!signature || !signature.coordinates) return null;

      const coordinates = signature.coordinates || {};
      const coordinateSpace = this.normalizeSignatureCoordinateSpace(
        signature.coordinateSpace || coordinates.coordinateSpace
      );
      const x = Number(coordinates.x);
      const y = Number(coordinates.y);
      const widthValue = Number(coordinates.width);
      const heightValue = Number(coordinates.height);
      const width =
        Number.isFinite(widthValue) && widthValue > 0
          ? widthValue
          : this.savedSignatureDefaultSize.width;
      const height =
        Number.isFinite(heightValue) && heightValue > 0
          ? heightValue
          : this.savedSignatureDefaultSize.height;

      if (!Number.isFinite(x) || !Number.isFinite(y)) return null;

      return {
        ...signature,
        id: `${record.id || "signature"}-${signature.signatureKey || index}`,
        documentVersion: record.documentVersion,
        pageNumber: Number(signature.pageNumber) || 1,
        coordinateSpace,
        coordinates: {
          x,
          y,
          width,
          height,
        },
      };
    },
    validateSignatureConfigForm() {
      this.resetSignatureConfigErrors();
      const apiCoordinates = this.getSignatureApiCoordinates();
      const signingOrder = Number(this.signatureConfigForm.signingOrder);
      const documentName = (this.signareadoctitle || this.getSignatureDocumentName() || "").trim();
      let isValid = true;

      if (!apiCoordinates || !apiCoordinates.coordinates.width || !apiCoordinates.coordinates.height) {
        this.signatureConfigErrors.coordinates = "Please draw the signature area on the PDF.";
        isValid = false;
      }

      if (!documentName) {
        this.signatureConfigErrors.documentName = "Document title is required.";
        isValid = false;
      }

      if (!Number.isFinite(signingOrder) || signingOrder <= 0) {
        this.signatureConfigErrors.signingOrder = "Please enter a valid signing order.";
        isValid = false;
      }

      if (!this.signatureConfigForm.displayName.trim()) {
        this.signatureConfigErrors.displayName = "Please enter display name.";
        isValid = false;
      }

      if (!this.signatureConfigForm.role) {
        this.signatureConfigErrors.role = "Please select role.";
        isValid = false;
      }

      if (!isValid) {
        alert("Please fill all mandatory fields.");
      }

      return isValid;
    },
    async saveSignatureConfiguration() {
      if (this.savingSignatureConfig || !this.validateSignatureConfigForm()) return;

      const idtoken = store.getters.getIdToken;
      const payload = this.createSignatureConfigPayload();
      this.savingSignatureConfig = true;

      try {
        const res = await axios.post(`${this.baseurl}/signature/signatureconfig/createconfig`, payload, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        });

        console.log("Signature configuration saved", res.data);
        alert("Signature configuration saved successfully.");
        this.resetSignatureConfiguration();
        await this.getSavedSignatureConfigurations();
        await this.setfilename();
      } catch (err) {
        console.error("Error saving signature configuration:", err);
        const message =
          err &&
          err.response &&
          err.response.data &&
          (err.response.data.message || err.response.data.detail);
        alert(message || "Unable to save signature configuration.");
      } finally {
        this.savingSignatureConfig = false;
      }
    },
    roundCoordinate(value) {
      return Math.round(value * 100) / 100;
    },
    inferFormatFromUrl(url) {
      const ext = (url.split("?")[0].split(".").pop() || "").toLowerCase();
      return ext || "";
    },

    setDocumentViewerSource(primary, fallback = "") {
      this.sourceFallback = fallback;
      this.hasTriedFallbackSource = false;
      this.source = primary;
      this.officeurl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(this.source)}`;
      this.$nextTick(() => this.updatePdfViewerWidth());

      if (!this.format) this.format = this.inferFormatFromUrl(this.source).toUpperCase();
    },

    onImageLoad() {
      this.isDocLoading = false;
    },
    onPdfLoaded(pdfDocument) {
      this.isDocLoading = false;
      this.pdfDocument = pdfDocument || null;
      this.$nextTick(async () => {
        this.updatePdfViewerWidth();
        this.onPdfScroll();
        await this.cachePdfPageSizes();
        await this.getSavedSignatureConfigurations();
      });
    },
    onPdfRendered() {
      this.$nextTick(() => {
        this.updatePdfViewerWidth();
        this.onPdfScroll();
      });
    },
    onOfficeLoad() {
      this.isDocLoading = false;
    },

    async approveLabel() {
      if (this.presentPage === "TmfDocReviewList" || this.presentPage === "TmfDocQcList") {
        this.approveButtonLabel = "Complete";
      }
    },

    async getVersionHistory() {
      const idtoken = store.getters.getIdToken;
      await axios
        .get(`${this.baseurl}/etmf/document/documentversion?documentId=${this.referenceId}`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          this.versionList = res.data;
          this.newversionforsigner = this.versionList[0]?.version;
        })
        .catch(() => {
          this.versionList = [];
        });
    },

    async checkqcReviewApproval(version = "") {
      const idtoken = store.getters.getIdToken;
      try {
        const res = await axios.get(
          `${this.baseurl}/etmf/document/approvalreviewerqccount?id=${this.referenceId}&studyId=${store.getters.getStudyIs}&version=${version}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );

        this.qcReviewApprovalStatus = {
          approvalCount: res.data.approvalCount || 0,
          reviewerCount: res.data.reviewerCount || 0,
          qcCount: res.data.qcCount || 0,
          isConfig: res.data.isConfig || 0,
        };
      } catch (err) {
        console.error("Error fetching QC Review Approval Status:", err);
        this.qcReviewApprovalStatus = {
          approvalCount: 0,
          reviewerCount: 0,
          qcCount: 0,
          isConfig: 0,
        };
      }
    },

    uploadDocumentModalClose() {
      this.list = [];
      this.uploadDocumentModal = false;
      this.getVersionHistory();
    },

    async getStudyBasedUsers() {
      const idtoken = store.getters.getIdToken;
      await axios
        .get(`${this.baseurl}/account-core/user/getstudybasedusers?studyid=${store.getters.getStudyIs}`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          if (res.data.entities && res.data.entities.length) {
            this.ownerList = res.data.entities.sort((a, b) => a.firstName.localeCompare(b.firstName));
          }
          this.setCurrentUser(this.ownerList);
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async setCurrentUser(data) {
      const idtoken = store.getters.getIdToken;
      const userEmail = jwt_decode(idtoken).email.trim();
      const userObject = data.find((item) => item.email === userEmail);
      if (userObject) {
        this.currentUser = `${userObject.firstName} ${userObject.lastName}`;
      }
    },

    async NewDocVersion() {
      try {
        this.uploadDocumentModal = true;
        this.getStudyBasedUsers();
        this.documentEdit = true;

        this.docTitle = "";
        this.docVersion = "";
        this.documentUploadFields = {
          owner: "",
          documentTitle: "",
          expiryDate: "",
          description: "",
          changesHistory: "",
          documentType: "",
        };
        this.addsigner = false;
        this.bookmarklist = [];
        this.signuserList = [];
        this.list = [];

        const idtoken = store.getters.getIdToken;
        const response = await axios.get(
          `${this.baseurl}/etmf/document/getnewversiondocumentitemdetails?documentId=${this.referenceId}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );

        const data = response.data;
        this.docTitle = data.documentTitle || "";
        this.docVersion = data.version || "";
        this.selectedversionid = data.version ? data.version : this.selectedversionid;
        this.documentUploadFields.owner = data.owner || "";
        this.documentUploadFields.documentTitle = data.documentTitle || "";
        this.documentUploadFields.expiryDate = data.expiryDate || "";
        this.documentUploadFields.description = data.description || "";
        this.documentUploadFields.changesHistory = data.changesHistory || "";
        this.documentUploadFields.documentType = data.documentType || "";
        this.bookmarklist = data.bookmarkList || [];
        this.signuserList = data.signUserList || [];
        this.addsigner = this.bookmarklist.length > 0;
        this.list = data.attachedFiles || [];
      } catch (error) {
        console.error("Error fetching new version document details:", error);
        this.$toast?.error?.("Unable to load document version details");
      }
    },

    async showAlert(message) {
      this.issigned = true;
      this.showdocsigniframe = false;
      console.log("Message from iframe:", message);
      const idtoken = store.getters.getIdToken;
      const payload = { envelopeId: this.envelopeId };
      try {
        await axios.post(`${this.baseurl}/etmf/docusign/envelopesent`, payload, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        });
      } catch (err) {
        console.error(err);
      }
      await this.setfilename();
      await this.setActionBtnVisiblity(this.versiondetails, this.loggedinUser.email);
    },

    testiframefun() {
      this.testiframe = true;
    },

    async docuSignCreated({ envelopeId, embeddedUrl }) {
      alert("Signers added successfully,Please proceed to add bookmarks on the next screen.");
      this.resetSignatureConfiguration();
      this.envelopeId = envelopeId;
      this.docsignurl = embeddedUrl;
      this.isSignLoading = true;
      this.showdocsigniframe = true;
      this.showDocRecipient = false;
    },

    // async setfilename() {
    //   try {
    //     const idtoken = store.getters.getIdToken;
    //     const res = await axios.get(
    //       `${this.baseurl}/etmf/document/getdocumentdetails?documentId=${this.referenceId}`,
    //       {
    //         headers: {
    //           Authorization: "Bearer " + idtoken,
    //           "Content-Type": "application/json",
    //         },
    //       }
    //     );

    //     if (res.data.docusign && res.data.docusign.recipients) {
    //       this.docusigndata = res.data.docusign.recipients;
    //     }

    //     const d = res.data.document || {};
    //     this.docDetails = d;
    //     this.NewFile = d.name || this.filename || "";
    //     this.format = d.type;

    //     if (Array.isArray(d.userPermission) && d.userPermission[0]?.permission) {
    //       const perms = d.userPermission[0].permission;
    //       this.canSelectApprovers = perms.includes("Select Approver");
    //       this.canSelectReviewers = perms.includes("Select Reviewer");
    //       this.canSelectQC = perms.includes("Select Qc");
    //       this.canUpload = perms.includes("Upload");
    //       this.canSelectSigners = perms.includes("Select Signer");
    //       this.canCompleteDocument = perms.includes("Complete Document");
    //     } else {
    //       this.canSelectApprovers =
    //         this.canSelectReviewers =
    //         this.canSelectQC =
    //         this.canUpload =
    //         this.canCompleteDocument =
    //           false;
    //     }

    //     this.issigned = !!d.isSignConfig;
    //     this.completionStatus = d.documentStatus || "";
    //     const docuSign = res.data.docusign || {};
    //     this.signstatus = docuSign.status || "";

    //     await this.getvesiondetails(this.versionId);
    //     return;
    //   } catch (e) {
    //     // fall through to file svc
    //   }

    //   try {
    //     this.NewFile = this.filename || this.NewFile || "";
    //     this.format = (this.NewFile.split(".").pop() || "").toUpperCase();
    //     await axios.get(
    //       `${this.fileuploadurl}/file/${this.referenceId}?versionid=${this.versionId}`,
    //       { responseType: "blob" }
    //     );
    //   } catch (e) {
    //     console.error("Filename/details fallback failed", e);
    //   }
    // },
    async setfilename() {
      try {
        const idtoken = store.getters.getIdToken;
        const res = await axios.get(
          `${this.baseurl}/etmf/document/getdocumentdetails?documentId=${this.referenceId}&version=${this.selectedversionid}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );

        if (Array.isArray(res.data.docusign)) {
          const matched = res.data.docusign.find(d => String(d.documentVersion) === String(this.selectedversionid));
          this.envelopeId = matched ? matched.envelopeId : null;

          this.docusigndata = matched && matched.recipients ? matched.recipients : [];
          this.signstatus = matched && typeof matched.status !== "undefined" ? matched.status : "";
        } else {
          this.envelopeId = null;
          this.docusigndata = [];
          this.signstatus = "";
        }
        const d = res.data.document || {};
        this.docDetails = d;
        this.NewFile = d.name || this.filename || "";
        this.format = d.type;

        if (Array.isArray(d.userPermission) && d.userPermission[0]?.permission) {
          const perms = d.userPermission[0].permission;
          this.canSelectApprovers = perms.includes("Select Approver");
          this.canSelectReviewers = perms.includes("Select Reviewer");
          this.canSelectQC = perms.includes("Select Qc");
          this.canUpload = perms.includes("Upload");
          this.canSelectSigners = perms.includes("Select Signer");
          this.canCompleteDocument = perms.includes("Complete Document");
        } else {
          this.canSelectApprovers =
            this.canSelectReviewers =
            this.canSelectQC =
            this.canUpload =
            this.canCompleteDocument =
            false;
        }

        this.issigned = !!d.isSignConfig;
        this.documentDescription = d.documentDescription;
        this.completionStatus = d.documentStatus || "";

        if (Array.isArray(res.data.docusign) && res.data.docusign.length > 0) {
          const lastDocuSign = res.data.docusign[res.data.docusign.length - 1];
          this.signstatus = lastDocuSign.status || "";
        } else {
          this.signstatus = "";
        }

        await this.getvesiondetails(this.selectedversionid);
        return;
      } catch (e) {
      }

      try {
        this.NewFile = this.filename || this.NewFile || "";
        this.format = (this.NewFile.split(".").pop() || "").toUpperCase();
        await axios.get(
          `${this.fileuploadurl}/file/${this.referenceId}?versionid=${this.selectedversionid}`,
          { responseType: "blob" }
        );
      } catch (e) {
        console.error("Filename/details fallback failed", e);
      }
    }
    ,

    async setdoc(forceReload = false) {
      this.resetSignatureConfiguration();
      this.pdfDocument = null;
      this.pdfPageSizes = {};
      this.isDocLoading = true;

      const cacheQuery = forceReload ? `&_=${Date.now()}` : "";
      const primary = `${this.baseurl}/etmf/document/documentfile/${this.referenceId}?version=${this.selectedversionid}${cacheQuery}`;
      const fallback = `${this.fileuploadurl}/file/${this.referenceId}?versionid=${this.selectedversionid}${cacheQuery}`;

      this.setDocumentViewerSource(primary, fallback);
    },

    async previousPage() {
      if (this.presentPage === "folderDocLogin" || this.presentPage === "etmf") {
        this.$router.push("/etmf");
      } else {
        this.$router.go(-1);
      }
    },

    async getvesiondetails(passedVersion) {
      console.log("inside getversiondetails function.....!!!!!!");
      try {
        this.passversiontodocusign = passedVersion;
        const versions =
          this.docDetails && Array.isArray(this.docDetails.documentVersions)
            ? this.docDetails.documentVersions
            : [];

        const key = String(passedVersion == null ? "" : passedVersion).trim();

        let match = null;
        if (key) {
          match = versions.find((v) => String(v.version).trim() === key) || null;
        } else {
          match =
            versions.slice().sort((a, b) => Number(b.version) - Number(a.version))[0] || null;
        }

        this.versiondetails = match || {};
        return match;
      } catch (e) {
        console.error("getVersionDetails error:", e);
        this.versiondetails = {};
        return null;
      }
    },

    /* Document approval functionality starts*/
    openApprovalModal(Approvaltype) {
      this.selectedApprovalType = Approvaltype;
      this.documentApprovalModal = true;
      this.approvals.approveList = [];
      this.approvals.version = this.selectedversionid;
      this.listRoles();
    },

    async closeDocumentApprovalModal() {
      this.approvals.approveList = [];
      this.approvals.version = this.selectedversionid;
      this.roleList = [];
      this.designation = "";
      this.designationList = [];
      this.userList = [];
      this.documentApprovalModal = false;
      this.selectedApprovalType = "";
      this.selectedDueDate = "";
      this.showSave = false;

      await this.checkqcReviewApproval();
      await this.setfilename();
      await this.getApprovers();
      await this.getvesiondetails(this.selectedversionid);
      await this.setActionBtnVisiblity(this.versiondetails, this.loggedinUser.email);
    },

    async listRoles() {
      const idtoken = store.getters.getIdToken;
      await axios
        .get(`${this.baseurl}/account-core/roles/search?`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          if (res.data?.data?.length) {
            this.roleList = res.data.data.sort((a, b) => a.role_Name.localeCompare(b.role_Name));
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },

    onDocuSignFrameLoad() {
      this.isSignLoading = false;
    },

    async onChange(selected) {
      this.showSave = true;
      this.approvals.approveList = [];
      this.approvals.version = this.selectedversionid;
      this.userobject = [];
      this.userList = [];
      this.isSelectedUser = [];
      this.isRequired = [];

      if (Array.isArray(selected)) {
        for (let roleId of selected) {
          await this.getDesignationUser(roleId);
        }
      } else if (selected) {
        await this.getDesignationUser(selected);
      }
    },

    async getDesignationUser(role) {
      const idtoken = store.getters.getIdToken;
      await axios
        .post(
          `${this.baseurl}/account-core/user/getuserlistbyroles?studyid=${store.getters.getStudyIs}`,
          [`${role}`],
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          if (res.data && res.data.length) {
            const mergedList = [...this.userList, ...res.data];
            this.userList = mergedList
              .filter(
                (user, index, self) =>
                  index === self.findIndex((u) => u.email === user.email)
              )
              .sort((a, b) => a.name.localeCompare(b.name));
          }

          this.isRequired = [];
          this.isSelectedUser = [];
          this.isDisabled = [];
          this.userList.forEach((user, index) => {
            this.isRequired[index] = false;
            this.isSelectedUser[index] = false;
            this.isDisabled[index] = false;
            this.loadingSingleSave[index] = false;
          });

          this.getApprovers();
        })
        .catch((err) => {
          console.log(err);
        });
    },






    // async getDesignationUser(role) {
    //   const idtoken = store.getters.getIdToken;
    //   await axios
    //     .post(`${this.baseurl}/account-core/user/getuserlistbyroles?studyid=${store.getters.getStudyIs}`, [`${role}`], {
    //       headers: {
    //         Authorization: "Bearer " + idtoken,
    //         "Content-Type": "application/json",
    //       },
    //     })
    //     .then((res) => {
    //       if (res.data && res.data.length) {
    //         this.userList = res.data.sort((a, b) => a.name.localeCompare(b.name));
    //       }
    //       this.isRequired = [];
    //       this.isSelectedUser = [];
    //       this.isDisabled = [];
    //       this.userList.forEach((user, index) => {
    //         this.isRequired[index] = false;
    //         this.isSelectedUser[index] = false;
    //         this.isDisabled[index] = false;
    //         this.loadingSingleSave[index] = false;
    //       });
    //       this.getApprovers();
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // },

    async getApprovers() {
      this.approvals.version = this.selectedversionid;
      const idtoken = store.getters.getIdToken;
      await axios
        .get(
          `${this.baseurl}/etmf/document/getapprovers?documentId=${this.referenceId}&versionNumber=${this.selectedversionid}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.getApproverList = res.data || [];
          this.approversEmails = [];

          this.isRequired = [];
          this.isSelectedUser = [];
          this.isDisabled = [];
          this.userList.forEach((user, index) => {
            const approver =
              this.getApproverList.find(
                (a) => a.approvedByEmail === user.email || a.approvedByEmail === user.emailId
              ) || null;
            if (approver) {
              this.isRequired[index] = !!approver.isRequired;
              this.isSelectedUser[index] = true;
              this.isDisabled[index] = approver.approvedStatus === "Approved";
              this.approversEmails.push(approver.approvedByEmail);
            } else {
              this.isRequired[index] = false;
              this.isSelectedUser[index] = false;
              this.isDisabled[index] = false;
            }
          });

          this.approvals.approveList = this.getApproverList.map((a) => ({
            approvalType: a.approvalType || this.approvalType,
            approvalTypeID: a.approvalTypeID || this.designation,
            approvedByEmail: a.approvedByEmail,
            isRequired: !!a.isRequired,
            comments: a.comments || "",
          }));
        })
        .catch((err) => {
          console.log("error in multiple approve", err);
        });
    },

    selectall() {
      this.removeUser = [];
      this.approvals.approveList = [];
      this.approvals.version = this.selectedversionid;
      const checkBoxall = document.getElementById("selectAllDocumentApprovers");
      if (checkBoxall.checked === true) {
        this.userList.forEach((users, index) => {
          if (this.isDisabled[index] === true) {
            this.isDisabled[index] = true;
          } else {
            this.userobject[users.userId] = true;
            this.isSelectedUser[index] = true;
            this.isRequired[index] = false;
            this.approvals.approveList.push({
              approvalType: this.approvalType,
              approvalTypeID: this.designation,
              approvedByEmail: users.emailId || users.email,
              isRequired: false,
              comments: "",
            });
          }
        });
      } else {
        this.userobject = [];
        this.approvals.approveList = [];
        this.approvals.version = this.selectedversionid;
        this.userList.forEach((user, index) => {
          if (this.isDisabled[index] === true) {
            this.isDisabled[index] = true;
          } else {
            this.userobject[user.userId] = false;
            this.isRequired[index] = false;
            this.isSelectedUser[index] = false;
            this.removeUser.push(user.email || user.emailId);
          }
        });
      }
    },

    onDocError(e) {
      if (
        this.sourceFallback &&
        !this.hasTriedFallbackSource &&
        this.source !== this.sourceFallback
      ) {
        this.hasTriedFallbackSource = true;
        this.source = this.sourceFallback;
        this.officeurl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(this.source)}`;
        return;
      }

      this.isDocLoading = false;
      this.resetSignatureConfiguration();
      console.error("Document load error", e);
    },

    async versionViewer(versionId, versionType, version) {
      if (this.selectedversionid === version) return;
      this.resetSignatureConfiguration();
      this.selectedversionid = version;
      this.isDocLoading = true;
      this.format = (versionType || "").toUpperCase();

      const primary = `${this.baseurl}/etmf/document/documentfile/${this.referenceId}?version=${version}`;
      const fallback = `${this.fileuploadurl}/file/${this.referenceId}?versionid=${version}`;

      this.setDocumentViewerSource(primary, fallback);
      // await this.getvesiondetails(version);
      await this.checkqcReviewApproval(version);


      await this.setfilename();
      await this.getApprovers();
      await this.setActionBtnVisiblity(this.versiondetails, this.loggedinUser.email);

    },

    async singleSaveApprover(user, index) {
      if (this.isDisabled[index] === true) {
        console.warn("disabled");
        return;
      }
      if (!this.isSelectedUser.some((val) => val) && !this.removeUser.length) {
        alert("Please enter the user");
        return;
      }

      if (this.isSelectedUser[index] === false) {
        const idtoken = store.getters.getIdToken;
        this.loadingSingleSave[index] = true;
        await axios
          .put(
            `${this.baseurl}/etmf/document/removeapprover?documentId=${this.referenceId}&versionNumber=${this.selectedversionid}&approverType=${this.selectedApprovalType}`,
            [user.email || user.emailId],
            {
              headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
              },
            }
          )
          .then(() => {
            this.loadingSingleSave[index] = false;
            alert(this.$t("navigations.approver removed successfully"));
            this.removeUser = [];
          })
          .catch((err) => {
            this.loadingSingleSave[index] = false;
            console.log("error in remove approver", err);
          });
        return;
      }

      if (this.isSelectedUser[index] === true) {
        const idtoken = store.getters.getIdToken;
        this.loadingSingleSave[index] = true;

        const payload = {
          documentId: this.referenceId,
          studyId: store.getters.getStudyIs,
          version: this.selectedversionid,
          actionType: this.selectedApprovalType,
        };

        if (this.selectedApprovalType === "approval") {
          payload.approveList = {
            approvalType: this.approvalType,
            approvalTypeID: this.designation,
            approvedByEmail: user.email || user.emailId,
            isRequired: this.isRequired[index],
            comments: "",
            dueDate: this.selectedDueDate ? this.selectedDueDate : null,
          };
        } else if (this.selectedApprovalType === "review") {
          payload.reviewList = {
            approvalType: this.approvalType,
            approvalTypeID: this.designation,
            reviewedByEmail: user.email || user.emailId,
            reviewedByUsername: user.username || user.name,
            isRequired: this.isRequired[index],
            dueDate: this.selectedDueDate ? this.selectedDueDate : null,
          };
        } else if (this.selectedApprovalType === "qc") {
          payload.qcList = {
            approvalType: this.approvalType,
            approvalTypeID: this.designation,
            qcByEmail: user.email || user.emailId,
            qcByUsername: user.username || user.name,
            isRequired: this.isRequired[index],
            dueDate: this.selectedDueDate ? this.selectedDueDate : null,
          };
        }

        await axios
          .post(`${this.baseurl}/etmf/document/singlesaveapprover`, payload, {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          })
          .then(() => {
            this.loadingSingleSave[index] = false;
            if (this.selectedApprovalType === "approval") {
              alert("Assigned approver successfully");
            } else if (this.selectedApprovalType === "review") {
              alert("Assigned reviewer successfully");
            } else if (this.selectedApprovalType === "qc") {
              alert("Assigned QC successfully");
            }
            this.checkqcReviewApproval("");
            this.setfilename();
          })
          .catch((err) => {
            console.log(`error in single ${this.selectedApprovalType}`, err);
            this.loadingSingleSave[index] = false;
          });
      } else {
        alert(this.$t("navigations.please select a user"));
      }
    },

    async removefile(index) {
      this.list.splice(index, 1);
    },

    async loadfile() {
      let fileload = document.getElementById("InPutFile");
      fileload.click();
    },

    async multipleSaveApprover() {
      const idtoken = store.getters.getIdToken;

      if (!this.isSelectedUser.some((val) => val) && this.removeUser.length === 0) {
        alert("Please select users");
        return;
      }

      if (this.isSelectedUser.every((val) => val === false) && this.removeUser.length > 0) {
        try {
          await axios.put(
            `${this.baseurl}/etmf/document/removeapprover?documentId=${this.referenceId}&versionNumber=${this.selectedversionid}&approverType=${this.selectedApprovalType}`,
            this.removeUser,
            {
              headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
              },
            }
          );
          alert(this.$t("navigations.approver removed successfully"));
          this.removeUser = [];
          this.closeDocumentApprovalModal();
          return;
        } catch (err) {
          console.error("Error in multiple remove approver", err);
          return;
        }
      }

      const payload = {
        documentId: this.referenceId,
        studyId: store.getters.getStudyIs,
        version: this.selectedversionid,
        actionType: this.selectedApprovalType,
        approveList: [],
        reviewList: [],
        qcList: [],
      };

      this.userList.forEach((user, index) => {
        if (this.isSelectedUser[index]) {
          const roleId = user.roleId ? String(user.roleId) : this.designation;

          if (this.selectedApprovalType === "approval") {
            payload.approveList.push({
              approvalType: this.approvalType,
              approvalTypeID: roleId,
              approvedByEmail: user.email || user.emailId,
              isRequired: !!this.isRequired[index],
              comments: "",
              dueDate: this.selectedDueDate ? this.selectedDueDate : null,
            });
          } else if (this.selectedApprovalType === "review") {
            payload.reviewList.push({
              approvalType: this.approvalType,
              approvalTypeID: roleId,
              reviewedByEmail: user.email || user.emailId,
              reviewedByUsername: user.username || user.name,
              isRequired: !!this.isRequired[index],
              dueDate: this.selectedDueDate ? this.selectedDueDate : null,
            });
          } else if (this.selectedApprovalType === "qc") {
            payload.qcList.push({
              approvalType: this.approvalType,
              approvalTypeID: roleId,
              qcByEmail: user.email || user.emailId,
              qcByUsername: user.username || user.name,
              isRequired: !!this.isRequired[index],
              dueDate: this.selectedDueDate ? this.selectedDueDate : null,
            });
          }
        }
      });

      try {
        await axios.post(`${this.baseurl}/etmf/document/multiplesaveapprover`, payload, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        });
        if (this.selectedApprovalType === "approval") {
          alert("Assigned approvers successfully");
        } else if (this.selectedApprovalType === "review") {
          alert("Assigned reviewers successfully");
        } else if (this.selectedApprovalType === "qc") {
          alert("Assigned QCs successfully");
        }
        this.closeDocumentApprovalModal();
      } catch (err) {
        console.error(`Error in multiple ${this.selectedApprovalType}`, err);
      }
    },

    async addApprover(user, index) {
      if (this.isSelectedUser[index] === true) {
        this.removeUser.push(this.userList[index].email);
        const approver = {
          approvalType: this.approvalType,
          approvalTypeID: this.designation,
          approvedByEmail: user.email,
          isRequired: this.isRequired[index],
          comments: "",
        };
        this.approvals.approveList.push(approver);
        if (this.removeUser.some((data) => data === user.email)) {
          this.removeUser.splice(this.removeUser.indexOf(user.email), 1);
        }
      } else {
        this.isRequired[index] = false;
        this.removeUser.push(this.userList[index].email);
        const removeUser = this.userList[index].email;
        this.approvals.approveList.forEach((approver) => {
          if (approver.approvedByEmail === removeUser) {
            this.approvals.approveList.splice(this.approvals.approveList.indexOf(approver), 1);
          }
        });
      }
    },

    async addRequiredApprover(user, index) {
      if (this.isRequired[index] === true) {
        this.isSelectedUser[index] = true;
        if (!this.approvals.approveList.some((data) => data.approvedByEmail === user.email)) {
          const approver = {
            approvalType: this.approvalType,
            approvalTypeID: this.designation,
            approvedByEmail: user.email,
            isRequired: this.isRequired[index],
            comments: "",
          };
          this.approvals.approveList.push(approver);
        }

        if (this.removeUser.some((data) => data === user.email)) {
          this.removeUser.splice(this.removeUser.indexOf(user.email), 1);
        }
      }
    },

    async ApprovalStatus(value) {
      if (this.presentPage === "etmfdoc") {
        this.status = value ? "Approved" : "Rejected";
      } else if (this.presentPage === "TmfDocReviewList" || this.presentPage === "TmfDocQcList") {
        this.status = value ? "Completed" : "Rejected";
      }

      if (value) {
        if (confirm("Are you sure you want to proceed?")) {
          await this.approvalsave(value);
          this.closeDocumentApprovalModal();
        }
      } else {
        if (confirm("Are you sure you want to reject the document?")) {
          await this.approvalsave(value);
          this.closeDocumentApprovalModal();
        }
      }
    },

    async approvalsave(value) {
      const idtoken = store.getters.getIdToken;

      if (this.presentPage === "etmfdoc") {
        this.actionType = "approval";
      }
      if (this.presentPage === "TmfDocReviewList") {
        this.actionType = "review";
      }
      if (this.presentPage === "TmfDocQcList") {
        this.actionType = "qc";
      }

      if (this.presentPage === "folderDocLogin") {
        const actiontypepassed = localStorage.getItem("passedactiontype");
        if (actiontypepassed === "DocApprove") this.actionType = "approval";
        else if (actiontypepassed === "DocReview") this.actionType = "review";
        else if (actiontypepassed === "DocQC") this.actionType = "qc";
        else this.actionType = "approval";
      }

      await axios
        .put(
          `${this.baseurl}/etmf/document/approvereject`,
          {
            documentId: this.referenceId,
            version: this.selectedversionid,
            approvalStatus: this.status,
            comments: this.comments,
            actionType: this.actionType,
          },
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then(() => {
          if (value === true) {
            if (this.actionType === "approval") {
              alert("The document approved successfully.");
            } else if (this.actionType === "review") {
              alert("The document review completed successfully.");
            } else if (this.actionType === "qc") {
              alert("The document QC completed successfully.");
            }
          } else {
            alert("The document rejected successfully.");
          }
          this.getApprovalStatus();
          this.checkqcReviewApproval("");
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async getApprovalStatus() {
      const idtoken = store.getters.getIdToken;
      if (this.presentPage === "etmfdoc" || this.presentPage === "etmfuserdashboard") {
        this.actionType = "approval";
      }
      if (this.presentPage === "TmfDocReviewList") {
        this.actionType = "review";
      }
      if (this.presentPage === "TmfDocQcList") {
        this.actionType = "qc";
      }
      await axios
        .get(
          `${this.baseurl}/etmf/document/approvalbyid?documentId=${this.referenceId}&version=${this.selectedversionid}&actionType=${this.actionType}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.approvaldetails = res.data;
          this.showValue = this.approvaldetails.approvedStatus;
        });
    },
    /* Document approval functionality ends*/

    async openDocRecipientModal() {
      this.showDocRecipient = true;
    },
    async closeRecipientModal() {
      this.showDocRecipient = false;
    },

    async CompleteDocument(status) {
      const idtoken = store.getters.getIdToken;
      if (confirm("Are you sure you want to complete the document?")) {
        await axios
          .put(
            `${this.baseurl}/etmf/document/changedocumentstatus?docId=${this.referenceId}&status=${status}&version=${this.selectedversionid}`,
            {},
            {
              headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
              },
            }
          )
          .then(() => {
            alert("The document completed successfully.");
            this.getApprovalStatus();
            this.checkqcReviewApproval("");
            this.setfilename();
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },

    async getTokenInfo() {
      this.loggedinUser = jwt_decode(store.getters.getIdToken);
    },

    async setActionBtnVisiblity(docDetails, userEmail) {
      console.log("docdetails isss !!!!!!", docDetails);
      const d = docDetails || {};

      if (Array.isArray(d.approval) && d.approval.length > 0) {
        console.log("inside approval array...", d.approval);
        const approval = d.approval.find(a => a.approvedByEmail === userEmail);
        if (approval) {
          this.statuses.approved.email = approval.approvedByEmail;
          this.statuses.approved.status = approval.approvedStatus;
          this.statuses.approved.actionTime = this.filter(approval.approvedDatetime);
        }
      }
      else {

        this.statuses.approved = {
          "email": "",
          "status": "",
          "actionTime": ""
        }
      }
      if (Array.isArray(docDetails.qc) && docDetails.qc.length > 0) {
        console.log("inside qc array...", docDetails.qc);
        const qc = docDetails.qc.find(q => q.qcByEmail === userEmail);
        if (qc) {
          this.statuses.qced.email = qc.qcByEmail;
          this.statuses.qced.status = qc.qcStatus;
          this.statuses.qced.actionTime = this.filter(qc.qcCompletedDatetime);

        }
      }
      else {

        this.statuses.qced = {
          "email": "",
          "status": "",
          "actionTime": ""
        }

      }
      if (Array.isArray(docDetails.reviewer) && docDetails.reviewer.length > 0) {
        console.log("inside reviewer array...", docDetails.reviewer);
        const reviewer = docDetails.reviewer.find(r => r.reviewedByEmail === userEmail);
        if (reviewer) {
          this.statuses.reviewed.email = reviewer.reviewedByEmail;
          this.statuses.reviewed.status = reviewer.reviewedStatus;
          this.statuses.reviewed.actionTime = this.filter(reviewer.reviewedDatetime);
        }
      }
      else {
        this.statuses.reviewed = {
          "email": "",
          "status": "",
          "actionTime": ""
        }

      }

      if (Array.isArray(this.docusigndata) && this.docusigndata.length > 0) {
        console.log("inside docusigndata array...", this.docusigndata);
        const signed = this.docusigndata.find(s => s.recipientEmail === userEmail);
        if (signed) {
          this.statuses.signed.email = signed.recipientEmail;
          this.statuses.signed.status = signed.recipientStatus;
          this.statuses.signed.recipientSignOrder = signed.recipientSignOrder;
        }
      }
      else {
        this.statuses.signed = {
          "email": "",
          "status": "",
          "envelopeId": "",
          "actionTime": "",
          "completed": false,
          "timestamp": ""
        }
      }
    },

    completeProcess(processName) {
      if (!this.statuses[processName].completed) {
        const now = new Date();
        const formattedTime = now.toLocaleString();
        this.statuses[processName].completed = true;
        this.statuses[processName].timestamp = formattedTime;
        this.$router.push({ name: 'signerslist' });
      }
    },
    async gotodocumentsign(recipientEmail, recipientSignOrder) {
      this.redirectpath = "documentview/" + this.referenceId + "/" + this.selectedversionid;
      store.dispatch('setSigningFrom', this.redirectpath)
      console.log("Navigating to document sign with:", this.envelopeId, recipientEmail, recipientSignOrder);
      if (!this.statuses.signed.completed) {
        const now = new Date();
        const formattedTime = now.toLocaleString();
        // this.$set(this.statuses.signed, "completed", true);
        this.statuses.signed.timestamp = formattedTime;
      }

      // then navigate
      this.$router.push(`/signfrompopup/${this.envelopeId}/${recipientEmail}/${recipientSignOrder}`);
      await this.setfilename();
    },
    async openDocumentSignPopup(recipientEmail, recipientSignOrder) {
      console.log("Opening document sign popup for:", recipientEmail, recipientSignOrder);
      this.docSignPopupEmail = recipientEmail || (this.loggedinUser ? this.loggedinUser.email : "");
      this.docSignPopupOrder = recipientSignOrder;
      this.showDocumentSignPopup = true;
    },
    async closeDocumentSignPopup() {
      this.showDocumentSignPopup = false;
      this.docSignPopupEmail = "";
      this.docSignPopupOrder = "";
      await this.setfilename();
      await this.setActionBtnVisiblity(this.versiondetails, this.loggedinUser.email);
      await this.getSavedSignatureConfigurations();
      if (this.hasSignedDocument) {
        this.activeDocumentTab = 'signed';
      }
    },



    async ActionClicked(actionType) {
      this.showActionPopup = true;
      this.actionType = actionType;
      if (actionType == "approval") {
        this.popupTitle = "Approve";
      }
      if (actionType == "qc") {
        this.popupTitle = "QC";
      }
      if (actionType == "review") {
        this.popupTitle = "Review";
      }

      if (actionType == "review") {
        if (this.statuses.approved.status != 'Pending') {
          this.actionStatus = this.statuses.approved.status;
        }
      }
    },
    filter(v) {
      if (!v) return "";
      const fmt = this.defaultdate || "YYYY-MM-DD";
      return moment(v).format(fmt);
    },
    async closeQCReviewModal() {
      this.showActionPopup = false;
      await this.setfilename();
      await this.setActionBtnVisiblity(this.versiondetails, this.loggedinUser.email);
    },
    openDetailPopup(type, data) {
      this.showDetailPopup = true;
      this.detailPopupType = type;
      this.detailPopupData = data;
    },
    openApprovalDetailModal(item) {
      this.selectedDetailType = "approval";
      this.selectedDetail = {
        status: item.approvedStatus,
        comment: item.comments,
        date: this.formatDateTime(item.approvedDatetime),
      };
      this.showDetailModal = true;
    },
    openReviewerDetailModal(item) {
      this.selectedDetailType = "review";
      this.selectedDetail = {
        status: item.reviewedStatus,
        comment: item.comments,
        date: this.formatDateTime(item.reviewedDatetime),
      };
      this.showDetailModal = true;
    },
    openQcDetailModal(item) {
      this.selectedDetailType = "qc";
      this.selectedDetail = {
        status: item.qcStatus,
        comment: item.comments,
        date: this.formatDateTime(item.qcCompletedDatetime),
      };
      this.showDetailModal = true;
    },
    closeDetailModal() {
      this.showDetailModal = false;
      this.selectedDetailType = "";
      this.selectedDetail = null;

    },
    formatDateTime(inputDate) {
      const date = new Date(inputDate);
      if (isNaN(date)) {
        console.error("Invalid date");
        return "";
      }

      const hours = date.getHours().toString().padStart(2, "0");
      const minutes = date.getMinutes().toString().padStart(2, "0");
      const seconds = date.getSeconds().toString().padStart(2, "0");

      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear().toString();

      return `${day}-${month}-${year} | ${hours}:${minutes}:${seconds}`;
    }

  }
};
